import { useEffect } from 'react';

const Ad = () => {
    useEffect(() => {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (err) {
            console.error('Error loading ad:', err);
        }
    }, []);

    return (
        <ins
            className="adsbygoogle"
            style={{ display: 'block' }}
            data-ad-format="fluid"
            data-ad-layout-key="-6r+dj-25-9f+nc"
            data-ad-client="ca-pub-3989185546069998"
            data-ad-slot="2168245170"
        />
    );
};

export default Ad; 